import { ParagraphText } from "../../../Libraries";
import { capitalize } from "@material-ui/core";
import { formatNum } from "../../../oscar-pos-core/constants";
import styles from "./styles.module.css";
import { useContext } from "react";
import { LanguageContext } from "../../../context/LanguageContext";
import { sentenceCase } from "../../../constants";

const AppBalanceDetailBox = ({
  amount,
  status,
  unpaidAmountVariant = "quickSale",
}) => {
  const [I18n] = useContext(LanguageContext);
  const isPaid =
    status?.toLowerCase() === "paid" ||
    status === I18n.itook ||
    status === I18n.money_in ||
    status === I18n.cash_out;
  const unpaidClass =
    unpaidAmountVariant === "expense" || status == I18n.itook
      ? styles.unPaidStatusExpense
      : styles.unPaidStatus;

  return (
    <div className={styles.amountSec}>
      {status ? (
        <ParagraphText className={styles.status}>
          {status === I18n.money_in || status === I18n.money_out
            ? status
            : sentenceCase(
                // Paid/Unpaid arrive in English; show the translated label
                ["paid", "unpaid"].includes(status?.toLowerCase?.())
                  ? I18n[status.toLowerCase()]
                  : status,
              )}
        </ParagraphText>
      ) : null}
      <ParagraphText
        className={`${styles.amount} ${status == I18n.itook ? unpaidClass : isPaid ? "" : unpaidClass}`}
      >
        Rs. {formatNum(amount)}
      </ParagraphText>
    </div>
  );
};

export default AppBalanceDetailBox;
